import React from 'react';
import { Query } from '@apollo/client/react/components';
import BillingAddress from 'buyside/components/presentation/UserAccount/BillingInformation/BillingAddress/billingAddress';
import { BillingAddressQuery } from 'interfaces/graphql-typings';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

const query = require('buyside/graphql/queries/BillingAddress.graphql');

const BillingAddressContainer: React.FC<{}> = (): React.ReactElement => (
  <Query<BillingAddressQuery, {}> query={query}>
    {({ loading, data = {} as BillingAddressQuery, error }): React.ReactElement => {
      if (error) throw error;
      if (loading) return <LoadingSpinner size={SIZES.LARGE} />;

      const billingAddress = data.currentUser && data.currentUser.billingAddress;

      return billingAddress ? (
        <BillingAddress
          city={billingAddress.address.city}
          lineOne={billingAddress.address.lineOne}
          lineTwo={billingAddress.address.lineTwo}
          postalCode={billingAddress.address.postalCode}
          state={billingAddress.address.state}
          country={billingAddress.address.country}
          name={billingAddress.name}
          email={billingAddress.email}
        />
      ) : (
        <div>You currently have no billing address on file.</div>
      );
    }}
  </Query>
);

export default BillingAddressContainer;
